<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>大屏配置列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="toolbar-box">
        <div class="list-box">
          <div class="l-list">
            <el-button-group>
              <el-button
                type="primary"
                icon="el-icon-plus"
                @click="addMap"
                v-if="flagAdd"
                >新增</el-button
              >
              <el-button
                style="margin-left: 20px"
                type="primary"
                icon="el-icon-plus"
                @click="moreParameters"
                >更多参数</el-button
              >
            </el-button-group>
          </div>
        </div>
      </div>

      <div class="content-box">
        <el-card class="table-card">
          <el-table
            ref="multipleTable"
            v-loading="loading"
            :data="listData"
            stripe
            class="table-list"
          >
            <el-table-column width="15"></el-table-column>
            <el-table-column label="地址名称" prop="location"></el-table-column>
            <el-table-column label="经度" prop="longitude"></el-table-column>
            <el-table-column label="纬度" prop="latitude"></el-table-column>
            <el-table-column fixed="right" label="操作" width="150">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  icon="el-icon-edit"
                  @click="editMap(scope.row)"
                  v-if="flagUpdate"
                ></el-button>
                <el-button
                  size="mini"
                  icon="el-icon-delete"
                  v-if="flagDel"
                  @click="deleteMap(scope.row.id)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </div>
    </div>
    <el-dialog
      class="confirms"
      :title="mapTitle"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-card class="box-card" v-if="mapType">
        <el-form label-width="100px">
          <el-form-item label="地址：">
            <el-input v-model="dataMap.location"></el-input>
          </el-form-item>
          <el-form-item label="经度：">
            <el-input v-model="dataMap.latitude"></el-input>
          </el-form-item>
          <el-form-item label="纬度：">
            <el-input v-model="dataMap.longitude"></el-input>
          </el-form-item>
          <el-form-item label="类型：" style="text-align: left">
            <el-select v-model="dataMap.type">
              <el-option value="0">0</el-option>
              <el-option value="1">1</el-option>
              <el-option value="2">2</el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-card>
      <el-card class="box-card" v-if="!mapType">
        <el-form label-width="100px">
          <el-form-item label="id：">
            <el-input v-model="updataMap.id" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="地址：">
            <el-input v-model="updataMap.location"></el-input>
          </el-form-item>
          <el-form-item label="经度：">
            <el-input v-model="updataMap.latitude"></el-input>
          </el-form-item>
          <el-form-item label="纬度：">
            <el-input v-model="updataMap.longitude"></el-input>
          </el-form-item>
          <el-form-item label="类型：" style="text-align: left">
            <el-select v-model="dataMap.type">
              <el-option value="0">0</el-option>
              <el-option value="1">1</el-option>
              <el-option value="2">2</el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-card>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="handleClose()">取 消</el-button>
        <el-button type="primary" size="mini" @click="add_edit()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { AxiosAjax } from "../js/axios.config";
export default {
  data() {
    return {
      mapType: false,
      mapTitle: "新 增",
      dialogVisible: false,
      loading: false,
      listData: [],
      dataMap: {
        latitude: "",
        location: "",
        longitude: "",
        type: 2,
      },
      updataMap: {
        id: "",
        latitude: "",
        location: "",
        longitude: "",
        type: 0,
      },
      deldataMap: {
        id: "",
      },
      author: "",
      flagLook: false,
      flagDel: false,
      flagUpdate: false,
      flagAdd: false,
    };
  },
  mounted() {
    this.buttonShow();
  },
  methods: {
    buttonShow() {
      if (localStorage.getItem("fx_menu_selected_jurisdiction")) {
        let jurisdiction = JSON.parse(
          localStorage.getItem("fx_menu_selected_jurisdiction")
        );
        let obj = jurisdiction[0].children.find(
          (obj) => obj.title === "系统中心"
        );
        let obj1 = obj.children.find((obj) => obj.title === "大屏配置");

        if (obj1.resources.find((item) => item.name == "View")) {
          this.flagLook = true;
        } else {
          this.flagLook = false;
        }
        if (obj1.resources.find((item) => item.name == "Delete")) {
          this.flagDel = true;
        } else {
          this.flagDel = false;
        }
        if (obj1.resources.find((item) => item.name == "Edit")) {
          this.flagUpdate = true;
        } else {
          this.flagUpdate = false;
        }
        if (obj1.resources.find((item) => item.name == "Add")) {
          this.flagAdd = true;
        } else {
          this.flagAdd = false;
        }

        obj1.resources.forEach((element) => {
          if (element.name == "View") {
            this.flagLook = element.selected;
          }
          if (element.name == "Add") {
            this.flagAdd = element.selected;
          }
          if (element.name == "Delete") {
            this.flagDel = element.selected;
          }
          if (element.name == "Edit") {
            this.flagUpdate = element.selected;
          }
        });
      }
    },
    add_edit() {
      const _this = this;
      if (this.mapType) {
        const params = this.dataMap;
        AxiosAjax({
          method: "post",
          url: "/cabinet/mapConfig/save",
          data: params,
          success: function (res) {
            _this.initData();
          },
        });
      } else {
        const params = this.updataMap;
        AxiosAjax({
          method: "post",
          url: "/cabinet/mapConfig/update",
          data: params,
          success: function (res) {
            _this.initData();
          },
        });
      }
      this.dialogVisible = false;
    },
    addMap() {
      this.dialogVisible = true;
      this.mapTitle = "新 增";
      this.mapType = true;
      this.dataMap = {
        latitude: "",
        location: "",
        longitude: "",
        type: 2,
      };
    },
    editMap(val) {
      this.dialogVisible = true;
      this.mapTitle = "编 辑";
      this.mapType = false;
      this.updataMap = {
        id: val.id,
        latitude: val.latitude,
        location: val.location,
        longitude: val.longitude,
        type: val.type,
      };
    },
    deleteMap(val) {
      const params = this.deldataMap;
      //执行删除操作
      const _parent = this;
      _parent
        .$confirm("确认要删除该记录吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(function () {
          AxiosAjax({
            method: "delete",
            url: "/cabinet/mapConfig/" + val,
            loading: true,
            data: params,
            successMsg: "已删除成功",
            success: function (res) {
              _parent.initData(); //重新加载列表
            },
          });
        })
        .catch(function () {});
    },
    handleClose() {
      this.dialogVisible = false;
    },

    //加载数据
    initData: function () {
      let _this = this;
      let sendUrl = "/cabinet/mapConfig/coordinatesList";
      AxiosAjax({
        url: sendUrl,
        beforeSend: function () {
          _this.loading = true;
        },
        success: function (res) {
          _this.listData = res.data.data;
          _this.totalCount = res.data.data.total;
          _this.pageIndex = res.data.data.index;
        },
        error: function (err) {
          _this.listData = [];
        },
        complete: function () {
          _this.loading = false;
        },
      });
    },
    moreParameters() {
      this.$router.push({ path: "/MoreParameters" });
    },
  },
  created: function () {
    //加载数据
    this.initData();
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/SetMap.vue